import React from "react";
import Box from "@mui/material/Box";

/**
 * Partial word mask: revealed letters plus larger empty circles for unknown letters.
 * @param {{ letters?: string[] }} props
 */
export default function WordRevealCircles({ letters = [] }) {
    const blanks = letters.filter((ch) => !ch).length;
    return (
        <Box
            role="img"
            aria-label={`${letters.filter(Boolean).join(" ")} ${blanks} hidden`}
            sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 1,
                py: 0.25,
            }}
        >
            {letters.map((ch, index) => {
                const revealed = Boolean(ch);
                const size = revealed ? 36 : 42;
                return (
                    <Box
                        key={`${index}-${ch || "_"}`}
                        sx={{
                            width: size,
                            height: size,
                            minWidth: size,
                            minHeight: size,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: revealed ? "2.5px solid #7EE0A8" : "2.5px solid rgba(238, 244, 255, 0.82)",
                            bgcolor: "transparent",
                            color: "#ECFDF5",
                            fontWeight: 800,
                            fontSize: revealed ? 20 : 0,
                            flexShrink: 0,
                            boxSizing: "border-box",
                        }}
                    >
                        {revealed ? ch : null}
                    </Box>
                );
            })}
        </Box>
    );
}
